import { render, staticRenderFns } from "./risk-level.vue?vue&type=template&id=b0dfae7e&scoped=true&"
import script from "./risk-level.vue?vue&type=script&lang=js&"
export * from "./risk-level.vue?vue&type=script&lang=js&"
import style0 from "./risk-level.vue?vue&type=style&index=0&id=b0dfae7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dfae7e",
  null
  
)

component.options.__file = "risk-level.vue"
export default component.exports